import React from 'react';
import { observer } from "mobx-react";
import PropTypes from 'prop-types';
import Icon from '../Icon';
import DatePick from '../DatePick';
import InputItem from '../InputItem';
import ButtonGroup from '../ButtonGroup';
import CheckButton from '../CheckButton';
import RefBox from '../RefBox';
import './index.less';

@observer
export default class Element extends React.Component {

  constructor(props) {
    super(props);
  }

  handleChange = (code, value) => {
    this.props.onChange && this.props.onChange(code, value);
  }

  getValue = (code, value) => {
    let _items = this.state.item;
    let it = item.find(it => it.code === code);
    if (it.component === 'refBox') {
      let refShowField = it.refShowField ? it.refShowField : '';
      const vs = (it.mode === 'single' ? [value] : value).map(it => {
        if (it) {
          let refValue = it.id;
          if (it.valueType.toLowerCase() === 'id') {
            refValue = it.id || it.ID || it.Id;
          }
          if (it.valueType.toLowerCase() === 'code') {
            refValue = it.code || it.Code;
          }
          if (it.valueType.toLowerCase() === 'name') {
            refValue = it.name || it.Name;
          }
          if (it.valueType.toLowerCase() === 'text') {
            refValue = it.Text || it.Name || it.Code || it.id || it.ID || it.Id || it.Value;
          }

          //处理refShowField为‘code+name’的情况
          let refShowFields = refShowField ? refShowField.split('+') : [];
          let texts = (refShowFields && refShowFields.length > 0) ? refShowFields.map(item => it[item]) : [];
          return {
            text: (texts && texts.length > 0) ? texts.join('/') : (it.$text || it.Name || refValue),
            value: refValue
          }
        } else {
          return {
            text: '',
            value: ''
          }
        }
      });
      if (it.mode === 'single') {
        return vs[0];
      } else {
        return vs;
      }
    } else {
      if (it.mode === 'single') {
        return {
          text: value.text,
          value: value.value
        }
      } else {
        return value.map(it => ({
          text: it.text,
          value: it.value
        }));
      }
    }
  }


  renderFilter = ({
    id,
    code,
    name,
    type,
    mode,
    component,
    value,
    visible,
    disabled,
    valueType,
    items,
    required,
    dtoName,
    writable,
    template,
    options
  }) => {
    let element;
    let opts = {
      id,
      visible,
      disabled,
      code,
      name,
      type,
      mode,
      valueType,
      items,
      required,
      name,
      dtoName,
      writable,
      template,
      ...options
    };
    switch (component) {

      case 'checkButton':
        element = (<CheckButton onChange={v => this.handleChange(code, v)} value={value} {...opts} />);
        break;
      case 'datePick':
        element = (<DatePick onChange={v => this.handleChange(code, v)} value={value} {...opts} />);
        break;
      case 'inputItem':
        element = (<InputItem onChange={v => this.handleChange(code, v)} value={value} {...opts} />);
        break;
      case 'buttonGroup':
        element = (<ButtonGroup onChange={v => this.handleChange(code, v)} value={value} {...opts} />);
        break;
      case 'refBox':
        element = <RefBox onChange={v => this.handleChange(code, v)} value={value} {...opts} />;
        break;
      case 'refBoxInput':
        element = <RefBox onChange={v => this.handleChange(code, v)} value={value} writable {...opts} />;
        break;
      default:
        element = null;
        break;
    }
    return (<div key={code} className='filter'>
      {name ? <label htmlFor={code} className={`${required ? 'required': ''} filter-label`}><span style={{color: '#FF4F6D'}}>{required ? '*' : ''}</span>{name}</label> : null}
      {element}
      
    </div>);
  }

  render() {
    return (
      <React.Fragment>
        {this.renderFilter(this.props)}
      </React.Fragment>
    )
  }
}
